<script setup>
defineProps({
  match: {
    required: true,
    type: Object
  }
});
</script>

<template>
  <div class="p-3">
    <div class="bg-white rounded-2xl overflow-hidden">
      <!-- Teams -->
      <div class="p-3 space-y-2">
        <!-- Team 1 -->
        <div
          class="flex items-center gap-3 p-3 rounded-xl"
          :class="{
            'bg-green-50':
              match.isFinished && match.team1.score > match.team2.score
          }"
        >
          <ImgComponent
            :src="match.team1.logo"
            fallback="/images/match/t-shirt.svg"
            class="w-10 h-10 min-w-10 rounded-xl bg-gray-200 flex items-center justify-center"
            alt=""
          />
          <div class="flex-1 min-w-0 font-bold text-gray-800">
            {{ match.team1.name }}
          </div>
          <div
            class="w-9 h-9 rounded-lg flex items-center justify-center text-sm font-medium text-gray-500 bg-gray-100"
          >
            {{ match.team1.score ?? '-' }}
          </div>
        </div>

        <!-- Team 2 -->
        <div
          class="flex items-center gap-3 p-3 rounded-xl"
          :class="{
            'bg-green-50':
              match.isFinished && match.team2.score > match.team1.score
          }"
        >
          <ImgComponent
            :src="match.team2.logo"
            fallback="/images/match/t-shirt.svg"
            class="w-10 h-10 min-w-10 rounded-xl bg-gray-200 flex items-center justify-center"
            alt=""
          />
          <div class="flex-1 min-w-0 font-bold text-gray-800">
            {{ match.team2.name }}
          </div>
          <div
            class="w-9 h-9 rounded-lg flex items-center justify-center text-sm font-medium text-gray-500 bg-gray-100"
          >
            {{ match.team2.score ?? '-' }}
          </div>
        </div>
      </div>

      <!-- Heure + Cotes -->
      <div class="flex items-center gap-2 px-3 pb-3">
        <div class="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-secondary-100 border border-secondary-200">
          <svg class="w-4 h-4 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span class="text-sm font-bold text-secondary-700">{{ match.time }}</span>
        </div>

        <div v-if="match.isFinished" class="flex-1 flex items-center justify-center">
          <div class="flex items-center gap-1.5 px-4 py-2 rounded-full bg-green-100 text-green-700 text-sm font-semibold">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>Terminé</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
